import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ComponentsModule } from '@fi-app/components/components.module';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { RoleViewComponent } from './role-view/role-view.component';
import { RoleService } from './services/role.service';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RoleListComponent } from './role-list/role-list.component';
import { FiRoleEditModule } from './role-edit/role-edit.module';
import { RoleListContainerComponent } from './role-list-container/role-list-container.component';
import { RoleViewContainerComponent } from './role-view-container/role-view-container.component';
import { RoleRelationsComponent } from './role-relations/role-relations.component';
import { FiEditorPageModule } from '../components/fi-editor-page/fi-editor-page.module';
import { RoleShareContentComponent } from './role-share-content/role-share-content.component';
import { UIRouterModule } from '@uirouter/angular';
import { FiRoleStates } from '@fi-app/role/role-states';
import { FiPageHeaderButtonGroupModule } from '@fi-shared/fi-page-header-button-group/fi-page-header-button-group.module';
import { RoleHelperService } from './services/role-helper.service';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { RoleNewLayoutModule } from '@fi-app/role/role-new-layout/role-new-layout.module';
import { ExtendedRoleRightService } from './services/extended-role-right.service';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';
import { FiButtonBackNewModule } from '@fi-shared/fi-button-back-new/fi-button-back-new.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FiRoleActionHelperService } from './services/fi-role-action-helper.service';

@NgModule({
    imports: [
        CommonModule,
        UtilitiesModule,
        FormsModule,
        ComponentsModule,
        MatCheckboxModule,
        FiRoleEditModule,
        FiEditorPageModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        UIRouterModule.forChild(FiRoleStates),
        FiPageHeaderButtonGroupModule,
        FiPageHeaderModule,
        RoleNewLayoutModule,
        FiLocalSearch2Module,
        FiWrapperTableModule,
        FiItemsListModule,
        FiButtonBackNewModule,
        MatButtonModule,
        MatIconModule,
    ],
    declarations: [
        RoleViewComponent,
        RoleListComponent,
        RoleListContainerComponent,
        RoleViewContainerComponent,
        RoleRelationsComponent,
        RoleShareContentComponent,
    ],
    providers: [RoleService, RoleHelperService, ExtendedRoleRightService, FiRoleActionHelperService],
})
export class RoleModule {}
